import { ServiceAppService } from '../../../../security/service-app.service';
import { FileUpload } from '../../../../shared/fileupload/fileupload';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-update-bd-lista',
  templateUrl: './update-bd-lista.component.html',
  styleUrls: ['./update-bd-lista.component.scss']
})

export class UpdateBdListaComponent implements OnInit {

  cols: any[];

  first = 0;
  rows = 10;
  edit = false;

  dados: any[];
  enviaArquivo: any;

  _selectedColumns: any[];

  CategoriaFiltro = [];

  dado: any;
  selectedDados: any[];
  dadosExibicao = [];

  isCollapsed = true;
  tipoArquivo: any;
  loading: boolean;

  dadosDialog: boolean;
  submitted: boolean;
  dadosModal: boolean;

  codigos = [];
  categoriaItem = [];
  classificacao = [];
  classificacaoSelecionar = [];
  categoriaItemSelecionar = [];
  selectedCategoriaItem = false;

  displayImport: boolean = false;
  displayFiltros: boolean = false;

  totalPercent = 0;
  progressBarPerc: any;
  percentDone: number;
  selectedFile: any;
  localUrl: any[];

  progress = false;
  dataInicio: Date;
  dataFim: Date;

  filtros = {
    codigo: null,
    categoriaItem: '',
    classificacao: ''
  }

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private service: ServiceAppService,
    private config: PrimeNGConfig,
    private date: DatePipe) { }

  ngOnInit(): void {
    this.retornaDados();
    this.progressBarPerc = 0;

    this.cols = [
      { field: 'nome', header: 'Descrição' },
      { field: 'dataFormatada', header: 'Data' },
      { field: 'mensagemTratada', header: 'Resultado' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados('/update_bd').subscribe(res => {
      this.dados = res.dados;

      this.codigos = [];

      this.dados.forEach(usuario => {
        this.codigos.push({ label: usuario.codigo, value: usuario.codigo });
      });
      this.loading = false;
    });
  }

  recarregaDados() {
    this.dt.first = 0;

    this.retornaDados();
  }

  showDialog() {
    this.displayImport = true;
  }

  //Paginator
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dados ? this.first === (this.dados.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.dados ? this.first === 0 : true;
  }

}